
import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import classesReducer from "./slices/classSlice";
import userReducer from './slices/userSlice';
import { persistReducer, persistStore } from 'redux-persist';
import feesReducer from "./slices/feeSlice";
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

const userPersistConfig = {
  key: 'user',
  storage,
};

const persistedUserReducer = persistReducer(userPersistConfig, userReducer);

// Drop the old shared persistence record, which could contain another tenant's
// class and fee caches from before those slices stopped being persisted.
storage.removeItem('persist:root');

export const store = configureStore({
  reducer: {
    user: persistedUserReducer,
    classes: classesReducer,
    fees: feesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
